import React, { useEffect, useRef } from "react";
import { Modal, Table, Header } from "semantic-ui-react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import MainButton from "components/Buttons/MainButton";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "components/Form/Select";

const schemaValidation = Yup.object().shape({
	documentType: Yup.number().required("Champ requis"),
});

const DispensationModal = ({ open, close, options, submit, epn, folder }) => {
	const innerRef = useRef(null);

	useEffect(() => {
		// subscribe event
		document.body.addEventListener("keyup", enterEventListener);
		return () => {
			// unsubscribe event
			document.body.addEventListener("keyup", enterEventListener);
		};
	}, []);

	const enterEventListener = (e) => {
		const button = innerRef.current;
		if (button) button.props.onClick();
	};

	const getAnalysesListNotRelated = (values) => {
		if (folder.prescriptions.some((p) => p.analyses.some((a) => !a.aes_id))) {
			let list = folder.prescriptions
				.filter((p) => p.analyses.filter((a) => !a.aes_id))
				.flatMap((p) => p.analyses.filter((anal) => !anal.aes_id))
				.map((a) => {
					return { value: a.properties.code, label: a.properties.code, disabled: !Object.values(values).includes(a.properties.code) };
				});
			return list;
		}
		return [];
	};

	return (
		<Formik
			initialValues={{}}
			validationSchema={schemaValidation}
			onSubmit={(values) => {
				//TODO: call the submit function
				console.log("submit", values);
			}}
		>
			{({ submitForm, values }) => {
				return (
					<Form>
						{epn && (
							<Modal open={open} onClose={close} closeOnEscape closeOnDimmerClick size="small">
								<Modal.Header>Dispensation d'analyses liées à une eprescription nationale</Modal.Header>
								<Modal.Content>
									Veuillez associer ci-dessous toutes les analyses dipensées dans ce dossier.
									<Table basic="very" celled collapsing>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell>Analyse prescrite</Table.HeaderCell>
												<Table.HeaderCell>Analyse dispensée</Table.HeaderCell>
											</Table.Row>
										</Table.Header>

										<Table.Body>
											{epn.analyses.map((a) => (
												<Table.Row>
													<Table.Cell>
														<Header as="h4" image>
															<Header.Content>
																{a.aes_catalog_name || a.name}
																<Header.Subheader>{a.code || ""}</Header.Subheader>
															</Header.Content>
														</Header>
													</Table.Cell>
													<Table.Cell>
														{folder &&
														folder.prescriptions &&
														folder.prescriptions.some((p) => p.analyses.some((anal) => anal.aes_id === a.identifier)) ? (
															folder?.prescriptions
																?.filter((p) => p.analyses.filter((anal) => anal.aes_id === a.identifier))
																.flatMap((p) => p.analyses.filter((anal) => anal.aes_id === a.identifier))[0].properties.code
														) : (
															<Field
																component={Select}
																name={`a-${a.identifier}`}
																customlabel="Veuillez sélectionner une analyse présente dans le dossier"
																placeholder="Analyse à associer"
																options={getAnalysesListNotRelated(values)}
															/>
														)}
													</Table.Cell>
												</Table.Row>
											))}
										</Table.Body>
									</Table>
								</Modal.Content>
								<Modal.Actions>
									<MainButton ref={innerRef} text="Confirmer" onClick={submitForm} />
									<SecondaryButton onClick={() => close()}>Annuler</SecondaryButton>
								</Modal.Actions>
							</Modal>
						)}
					</Form>
				);
			}}
		</Formik>
	);
};

export default DispensationModal;
